<template>
  <div id="modelRight">
    <div>
      <div ref="cover" class="cover" @click.stop="cancelModel"></div>
      <div ref="allModel_r" class="allModel_r" style="pointer-events:none">
        <div style="pointer-events:auto" :style="{'width':minWidth === undefined || minWidth === null ?'800px':minWidth, 'right':minWidth === undefined || minWidth === null ?'-800px': 'calc(-100% + ' + minWidth + ')' }" class="content">
          <div style="box-shadow: 0px 0px 12px 2px rgba(243, 106, 32, 0.2);position: relative;z-index: 10;width: 100%;height: 100%">
            <div class="modelHead t_r">
              <i @click="cancelModel()" class="icon iconfont iconguanbi  " style="font-size: 18px;"></i>
            </div>
            <!--<div class="modelBody">-->
            <div class="modelTitle d_flex">
              <div>
                <i :class="newTitle.icon" class="f_w" style="font-size: 20px"></i>
                <span class="title f_w font16 m_l_5">{{ newTitle.name }}</span>
              </div>
            </div>
            <div class="model-line"></div>
            <div class="allModelPlaceRight">
              <slot>
                没内容
              </slot>
            </div>
            <div class="model-foot">
              <div v-if="OnButton === 0">
              </div>
              <div v-if="OnButton === 1">
                <button @click="resetModel()" class="suerButtonSolid m_r_10"><span>重置</span></button>
                <button @click="confirmModel()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
              </div>
              <div v-if="OnButton === 2">
                <button @click="resetModel()" class="suerButtonSolid m_r_10"><span>重置</span></button>
                <button @click="confirmModel()" class="suerButton"><span>确定</span></button>
              </div>
            </div>
          </div>
          <div class="contentleft" style="width: 260px" v-if="newMlData && newMlData.isModelLeft && parseInt(newMlData.isModelLeft) === 1">
            <div class="modelHead t_r notifyOuter">
              <i class="icon iconfont iconbangzhu colorYellowF36A20 f_w notifyer" style="font-size: 20px; float: left;"></i>
              <div class="notifyContent">仅展示前20行结果，不在此范围请输入查找</div>
              <i @click="cancelModelLeft()" class="icon iconfont iconyou colorYellowF36A20 " style="font-size: 18px;"></i>
            </div>
            <!--<div class="modelBody">-->
            <div class="modelTitle d_flex">
              <div style="width: 60%" class="NoWrap" :title="newMlData.topName">
                <span>{{newMlData.topName}}</span>
              </div>
              <div>
                <button @click="confirmModelLeft()" class="suerButton"><span>确定</span></button>
              </div>
            </div>
            <div class="leftDivbody">
              <nav>
                <i class="icon iconfont iconsousuo colorGray696969"></i>
                <input @input="serchLeft()" v-model="myKeyword" type="text"/>
              </nav>
              <ul>
                <li @click="selftLetF()" v-if="myLeftList.length > 0">全部
                  <span>共{{totalCnt}}条搜索结果</span>
                </li>
                <li @click="seltLeftID(item)" :class="item.isCheck ? 'active' : ''" :key="index" v-for="(item, index) in myLeftList"  v-if="myLeftList.length > 0">
                  <span class="NoWrap">{{ item.name }}</span>
                  <i v-if="item.isCheck" class="icon iconfont iconapproved"></i>
                </li>
                <li v-if="myLeftList.length === 0">暂无数据</li>
              </ul>
              <!-- <span class="totalCnt">共{{totalCnt}}条搜索结果</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timeOut
export default {
  name: 'modelRight',
  model: {
    event: 'sletModelId'
  },
  props: [
    'onButton',
    'minWidth',
    'fromUser',
    'title',
    'showModel',
    'mlData'
  ],
  data () {
    return {
      OnButton: parseInt(this.onButton),
      newMlData: this.mlData,
      sletModelId: [],
      newTitle: this.title,
      myLeftList: [],
      totalCnt: 0,
      myKeyword: '',
      modelId: [],
      midList: []
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    const that = this
    setTimeout(function () {
      that.$refs.cover.style.opacity = 1
      that.$refs.allModel_r.style.opacity = 1
      that.$refs.allModel_r.style.right = '0px'
    }, 10)
  },
  methods: { // 所有的方法封装
    cancelModel () {
      const that = this
      that.$refs.cover.style.opacity = 0
      that.$refs.allModel_r.style.opacity = 0
      that.$refs.allModel_r.style.right = '-100px'
      setTimeout(function () {
        that.$emit('on-cancel', '')
      }, 500)
    },
    confirmModel () {
      this.$emit('on-confirm', '')
    },
    confirmModel2 () {
      this.$emit('on-confirm2', '')
    },
    conTwoModel () {
      this.$emit('on-confirmTwo', '')
    },
    cancelModelLeft () {
      this.newMlData.isModelLeft = 0
    },
    confirmModelLeft () {
      this.sletModelId = JSON.parse(JSON.stringify(this.midList))
      this.$emit('sletModelId', this.sletModelId)
    },
    resetModel () {
      this.$emit('on-resetModel', '')
    },
    emptyId () {
      // this.sletModelId = []
      // setTimeout(p => {
      //   console.log(this.modelId)
      //   console.log(this.myLeftList)
      //   for (let i = 0; i < this.myLeftList.length; i++) {
      //     if (this.modelId.indexOf(this.myLeftList[i].id) >= 0) {
      //       this.$set(this.myLeftList[i], 'isCheck', true)
      //       if (this.myLeftList[i].isCheck) {
      //         this.sletModelId.push(this.myLeftList[i])
      //       }
      //     }
      //   }
      // }, 100)
      // alert(1)
    },
    getLeftSortList () {
      let data = {
        DbName: this.newMlData.DbName,
        Dickey: this.newMlData.Dickey,
        Table: this.newMlData.TableId,
        isNeedPermissionControl: this.newMlData.isNeedPermissionControl,
        Keyword: this.myKeyword,
        PageIndex: 1,
        PageSize: 20
      }
      let url = this.$commonJs.returnQuery('/api/Download/GetVauleByDicKey', data)
      this.$axiox.get(url).then(msg => {
        this.myLeftList = []
        // this.sletModelId = []
        this.totalCnt = msg.data.totals
        let list = msg.data.values || []
        for (let i = 0; i < list.length; i++) {
          let object = {
            id: list[i],
            name: list[i]
          }
          this.myLeftList.push(object)
        }
        for (let i = 0; i < this.myLeftList.length; i++) {
          if (this.modelId.indexOf(this.myLeftList[i].id) >= 0) {
            this.$set(this.myLeftList[i], 'isCheck', true)
          }
        }
      })
    },
    serchLeft () {
      clearTimeout(timeOut)
      timeOut = setTimeout(p => {
        this.getLeftSortList()
      }, 1000)
    },
    seltLeftID (item) {
      item.isCheck = !item.isCheck
      if (item.isCheck) {
        if (this.modelId.indexOf(item.id) >= 0) {
        } else {
          this.midList.push(JSON.parse(JSON.stringify(item)))
          this.modelId.push(JSON.parse(JSON.stringify(item.id)))
        }
      } else {
        if (this.modelId.indexOf(item.id) >= 0) {
          for (let i = 0; i < this.midList.length; i++) {
            if (this.midList[i].id === item.id) {
              this.midList.splice(i, 1)
            }
          }
          for (let i = 0; i < this.modelId.length; i++) {
            if (this.modelId[i] === item.id) {
              this.modelId.splice(i, 1)
            }
          }
        } else {
        }
      }
      this.$forceUpdate()
    },
    selftLetF () {
      for (let i = 0; i < this.myLeftList.length; i++) {
        this.$set(this.myLeftList[i], 'isCheck', false)
        this.modelId = []
      }
      this.midList = []
      this.$forceUpdate()
    }
  },
  components: {
  },
  watch: {
    onButton (val) {
      this.OnButton = parseInt(val)
    },
    mlData (val) {
      this.newMlData = val
      if (parseInt(val.isModelLeft) === 1) {
        this.myKeyword = ''
        this.getLeftSortList()
        this.modelId = val.leftIdList.map(p => { return p.id })
        this.midList = JSON.parse(JSON.stringify(val.leftIdList))
      }
    },
    title (val) {
      this.newTitle = val
    }
  }
}
</script>

<style scoped>
.allModel_r {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  left: 0;
  top: 0;
  z-index: 1001;
  opacity: 0
}
.allModel_r .content{
  display: inline-block;
  margin: auto;
  position: relative;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  /*box-shadow: 0px 0px 12px 2px rgba(243, 106, 32, 0.2);*/
  z-index: 10;
}
.contentleft {
  display: inline-block;
  margin: auto;
  position: absolute;
  top: 0;
  right: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  /*box-shadow: 0px 0px 12px 2px rgba(243, 106, 32, 0.2);*/
  vertical-align: top;
}
.allModel_r .content .modelHead{
  padding: 10px 0;
  margin: 0 10px;
}
.notifyOuter{
  position: relative;
}
.notifyer:hover +.notifyContent{
  display: block;
}
.notifyContent{
  display: none;
  position: absolute;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;
  left: 0;
  top: 34px;
  padding: 8px;
}
.modelTitle {
  margin: 0 10px;
  padding: 10px 0;
  /* border-bottom: 1px solid #F36A20; */
}
.modelTitle .title{
  color:#333;
  font-size: 16px;
}
.model-line{
  width: 28px;
  height: 4px;
  background: linear-gradient(58deg, #20B38C 0%, #48BEF5 100%);
  border-radius: 5px 5px 5px 5px;
  margin-left:15px;
}
.allModelPlaceRight {
  padding: 10px 0;
  height: calc(100% - 152px);
}
.leftDivbody {
  padding: 10px;
  height: calc(100% - 110px);
  overflow: auto;

}
.leftDivbody > nav {
  border-bottom: 1px solid  rgba(0, 0, 0, 0.15);;
  padding-bottom: 5px;
}
.leftDivbody > nav > input {
  width: calc(100% - 34px);
  padding: 5px;
  outline: none;
  border: none;
  background-color: transparent;
}
.leftDivbody > ul li {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: #313131;
}
.leftDivbody > ul li.active {
  color: #F36A20!important;
}
.leftDivbody > ul li > span {
  max-width: calc(100% - 30px);
}
.leftDivbody > .totalCnt {
  position: absolute;
  bottom: 20px;
  left: 83px;
}
.suerButton{
  background: #59D9A3;
  border-radius: 8px;
}
.suerButton,.suerButtonSolid{
  padding: 6px 16px;
}
.model-foot{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/modelRight.vue